import * as CourseOfStudyStoreActions from './courseofstudy.actions';
import * as CourseOfStudyStoreSelectors from './courseofstudy.selectors';
import * as CourseOfStudyStoreReducer from './courseofstudy.reducer';

export { CourseOfStudyStoreActions, CourseOfStudyStoreSelectors, CourseOfStudyStoreReducer };
